import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-store",
  "use": "icon-si-glyph-store-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-store\" id=\"icon-si-glyph-store\"><title>861</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(1.000000, 0.000000)\" fill=\"#434343\"><path d=\"M13.021,7.028 L13.021,12.042 L3,12.042 L3,7 L2.035,7 L2.035,15 L14,15 L14,7.028 L13.021,7.028 Z\" class=\"si-glyph-fill\" /><rect x=\"3\" y=\"0\" width=\"9.902\" height=\"0.929\" class=\"si-glyph-fill\" /><path d=\"M13.295,3.001 L12.984,2.046 L3.021,2.046 L2.685,3.001 L0.011,6.302 L1.345,6.97 L2.979,6.97 L2.979,5.938 L4.021,5.938 L4.021,6.97 L5.979,6.97 L5.979,5.938 L7.021,5.938 L7.021,6.97 L8.979,6.97 L8.979,5.938 L10.021,5.938 L10.021,6.97 L11.979,6.97 L11.979,5.938 L13.021,5.938 L13.021,6.97 L14.678,6.97 L15.969,6.302 L13.295,3.001 Z\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-store.svg
// module id = GFDV
// module chunks = 62